import { useState } from "react";
import "./VerifyCode.css"; // optional, for custom styles
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { PageNotFound } from "../../EssentialPage/EssentialPage";
import Cookies from "js-cookie";


const VerifyCode = () => {
    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [pageLoad, setPageLoad] = useState(true);
    const [pageNotFound, setPage] = useState(false);

    const LinkTO = useNavigate()

    const { id } = useParams()

    useState(() => {
        async function check() {
            let token = id;
            try {
                const response = await axios.post(
                    "http://localhost:5000/api/admin/verify/code/status",
                    { token }
                );
                console.log(response.data);
                setPageLoad(false)
            } catch (err) {
                // Axios error handling
                if (err.response) {
                    // Server responded with a status code outside 2xx
                    console.log("Error status:", err.response.status)
                    if (err.response.status === 400) {
                        setPage(true)
                    }
                } else if (err.request) {
                    // Request was made but no response
                    console.log("No response received:", err.request);
                } else {
                    // Something else
                    console.log("Error:", err.message);
                }
            }


        }
        check();
    })
    const handleVerify = async () => {
        setError("");
        setSuccess("");

        if (!code || code.length !== 6) {
            setError("Invalid Code!");
            return;
        }

        try {
            const res = await axios.post("http://localhost:5000/api/admin/login/code", { token: id, code });
            if (res.status === 200) {
                setSuccess("Code verified successfully ✅");
                // Redirect or proceed to dashboard
                console.log(res.data.token)
                // Set a cookie
                Cookies.set("token", res.data.token, {
                    expires: 1, // expires in 1 day
                    path: "/",  // accessible on all pages
                });
                LinkTO("/admin/dashboard")
            } else {
                setError(res.data.message || "Invalid code ❌");
            }
        } catch (err) {
            if (err.status === 401) {
                setError("Invalid Code❌");
            }
            else {
                setError("Server error. Try again later ❌");
            }
            console.error(err);

        }
    };

    return (
        <>
            {pageNotFound &&
                <PageNotFound />
            }
            {pageLoad ?
                <>Loading </> :
                <>
                    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                        <div className="card shadow-lg p-4 text-center" style={{ maxWidth: "400px", width: "100%", borderRadius: "20px" }}>
                            {/* Logo */}
                            <div className="mb-4">
                                <img
                                    src="https://via.placeholder.com/150x50?text=Your+Logo"
                                    alt="Logo"
                                    className="img-fluid"
                                />
                            </div>

                            <h4 className="mb-3">Enter Code</h4>
                            <p className="mb-3">Enter the 6-digit code sent to your email address</p>

                            <input
                                type="text"
                                className={`form-control text-center ${error ? "is-invalid" : ""}`}
                                placeholder="Enter code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                maxLength={6}
                            />

                            <button onClick={handleVerify} className="btn btn-primary w-100 mt-3">
                                Verify
                            </button>

                            {error && <div className="invalid-feedback d-block mt-2">{error}</div>}
                            {success && <div className="valid-feedback d-block mt-2">{success}</div>}
                        </div>
                    </div></>
            }

        </>


    );
};

export default VerifyCode;
